// extracted by mini-css-extract-plugin
module.exports = {"cursorPointer":"info_cursorPointer__3io4M"};